import { render, staticRenderFns } from "./RecipeLabels.vue?vue&type=template&id=5f455ee6&scoped=true"
import script from "./RecipeLabels.vue?vue&type=script&lang=ts"
export * from "./RecipeLabels.vue?vue&type=script&lang=ts"
import style0 from "./RecipeLabels.vue?vue&type=style&index=0&id=5f455ee6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f455ee6",
  null
  
)

export default component.exports